var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLanguageIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.179 21.474c1.088-2.096 1.699-5.24 1.804-8.474h4.967c-.396 3.962-3.116 7.244-6.771 8.474zM2.05 13h4.967c.104 3.234.716 6.378 1.804 8.474C5.166 20.244 2.447 16.962 2.05 13zM8.82 2.527C7.735 4.622 7.122 7.767 7.019 11H2.05c.396-3.962 3.115-7.243 6.77-8.473zM9.02 11c.185-5.45 1.854-9 2.98-9 1.128 0 2.797 3.55 2.983 9H9.019zm2.98 11c-1.126 0-2.795-3.55-2.98-9h5.963c-.186 5.45-1.855 9-2.982 9zm9.95-11h-4.966c-.105-3.233-.716-6.378-1.804-8.473 3.655 1.23 6.375 4.51 6.77 8.473zM12 0C5.384 0 0 5.383 0 12c0 6.618 5.384 12 12 12 6.618 0 12-5.382 12-12 0-6.617-5.382-12-12-12z",
    fill: "#B3B3B3",
    fillRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanguageIcon);
export default __webpack_public_path__ + "static/media/language-icon.8156b17b50e3ca9fc04784a514dbf13b.svg";
export { ForwardRef as ReactComponent };